<template>
  <artmisads-modal
    :open="open"
    title="Campaign Products"
    :width="1000"
    :maskClosable="false"
    :footer="null"
    :onCancel="close"
    :destroyOnClose="true"
  >
    <div class="campaign-products-modal">
      <div class="info-block">
        <div class="info-label">Campaign Name</div>
        <div class="info-value">{{ campaign.campaignName || '—' }}</div>
      </div>

      <div class="accept-row">
        <div class="accept-status-block">
          <div class="info-label">AcceptStatus</div>
          <!-- <template v-if="isNotAccepted(campaign.acceptStatus)">
            <span class="not-accepted-text">Not Accepted</span>
          </template> -->
          <!-- <template >
          
          </template> -->
          <Status
              :type="acceptStatusType()"
              :text="formatAcceptStatus(campaign.acceptStatus)"
              :noBorder="true"
            />
        </div>
        <artmisads-button
          v-if="isNotAccepted(campaign.acceptStatus)"
          type="primary"
          class="accept-btn"
          @click="onAccept"
        >
          Accept In Amazon Associate
        </artmisads-button>
      </div>

      <div class="products-title">Products</div>

      <artmisads-table
        v-model:pagination="pagination"
        :columns="columns"
        :data-source="dataSource"
        :change="onTableChange"
        :loading="load"
        :scroll="{ x: 900 }"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'product'">
            <div class="product-cell">
              <div class="product-img-wrap">
                <LogoImage :logoUrl="record.imageUrl" :brandName="record.productTitle" />
              </div>
              <span class="product-title">{{ record.productTitle || '-' }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'asin'">
            {{ record.asin || record.productAsin || '-' }}
          </template>
          <template v-else-if="column.key === 'category'">
            {{ record.category || record.productCategory || '-' }}
          </template>
          <template v-else-if="column.key === 'deal'">
            <div class="deal-cell">
              <product-deals-column
                v-for="item in record.productDeals || []"
                :key="item.id"
                :record="item"
              />
              <span v-if="!record.productDeals?.length" class="deal-empty">-</span>
            </div>
          </template>
          <template v-else-if="column.key === 'productPrice'">
            <span v-if="record.productPrice != null">
              {{ getCurrencySymbol(record) }} {{ formatMoney(record.productPrice) }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-else-if="column.key === 'stock'">
            {{ formatStock(record) }}
          </template>
        </template>
      </artmisads-table>
    </div>

    <StoreIdNoticeModal ref="storeIdNoticeModalRef" />
  </artmisads-modal>
</template>

<script setup>
import { ref, reactive, defineExpose } from 'vue'
import { message } from 'ant-design-vue'
import Status from '@/components/Status.vue'
import ProductDealsColumn from '@/components/productDealsColumn.vue'
import StoreIdNoticeModal from './storeIdNoticeModal.vue'
import { creatorConnectionsApi } from '@/server/index'
import { CURRENCY_DATA_MAPPER } from '@/contants/common'
import LogoImage from '~/components/LogoImage.vue'

const open = ref(false)
const load = ref(false)
const dataSource = ref([])
const campaign = ref({})
const marketplace = ref('')
const storeIdNoticeModalRef = ref(null)
const programId = ref('')
const pagination = reactive({
  total: 0,
  current: 1,
  size: 10,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50'],
})

const columns = [
  { title: 'Product', dataIndex: 'product', key: 'product', width: 280 },
  { title: 'ASIN', dataIndex: 'asin', key: 'asin', width: 140 },
  { title: 'Category', dataIndex: 'category', key: 'category', width: 120 },
  { title: 'Deal', dataIndex: 'deal', key: 'deal', width: 100 },
  { title: 'Price', dataIndex: 'productPrice', key: 'productPrice', width: 100 },
  { title: 'Stock', dataIndex: 'stock', key: 'stock', width: 100 },
]

const close = () => {
  open.value = false
}

const formatMoney = (val) => Number(val ?? 0).toFixed(2)

const getCurrencySymbol = (record) =>
  record?.currencySymbol ??
  CURRENCY_DATA_MAPPER[record?.currencyCode ?? record?.currency] ??
  '$'

const formatStock = (record) => {
  
  return record?.availability ?? record?.stockStatus ?? '—'
}

const formatAcceptStatus = (status) => {
  if (status === 'ACCEPTED' || status === 'accepted') return 'Accepted'
  if(status === 'NOT_ACCEPTED' || status === 'not_accepted' || status === 'NOT ACCEPTED' || status === 'Not Accepted') return 'Not Accepted'
  return status || '—'
}

const isNotAccepted = (status) =>
  status === 'NOT_ACCEPTED' ||
  status === 'not_accepted' ||
  status === 'NOT ACCEPTED' ||
  status === 'Not Accepted'

const acceptStatusType = () => {
   if(campaign.value.acceptStatus === 'ACCEPTED' || campaign.value.acceptStatus === 'accepted') return 'active'
   if(campaign.value.acceptStatus === 'NOT_ACCEPTED' || campaign.value.acceptStatus === 'not_accepted' || campaign.value.acceptStatus === 'NOT ACCEPTED' || campaign.value.acceptStatus === 'Not Accepted') return 'inactive'
   return 'inactive'
}

const onAccept = () => {
  if (campaign.value.hasAssociateStoreId) {
    if (campaign.value.jumpUrl) {
      window.open(campaign.value.jumpUrl, '_blank')
    } else {
      storeIdNoticeModalRef.value?.show()
    }
  } else {
    storeIdNoticeModalRef.value?.show()
  }
}

const onTableChange = ({ current, pageSize }) => {
  pagination.current = current
  pagination.size = pageSize
  pagination.pageSize = pageSize
  fetchProducts()
}

const fetchProducts = async () => {
  const campaignId = campaign.value.campaignId ?? campaign.value.id
  if (!campaignId) return
  load.value = true
  try {
    const res = await creatorConnectionsApi.getBonusProgramCampaignProducts({
      campaignId,
      page: pagination.current,
      size: pagination.size,
      programId: programId.value,
    })
    if (res?.success && res?.data) {
      const list = res.data.data ?? res.data
      dataSource.value = Array.isArray(list) ? list : []
      pagination.total = res.data.total ?? dataSource.value.length
    } else {
      dataSource.value = []
      pagination.total = 0
      if (res?.error) message.error(res.error)
    }
  } catch {
    dataSource.value = []
    pagination.total = 0
    message.error('Failed to load data')
  } finally {
    load.value = false
  }
}

const show = (record, marketplaceValue = '',programIdValue = '') => {
  campaign.value = record || {}
  marketplace.value = marketplaceValue
  programId.value = programIdValue
  pagination.current = 1
  open.value = true
  fetchProducts()
}

defineExpose({ show })
</script>

<style scoped lang="less">
.campaign-products-modal {
  .info-block {
    margin-bottom: 16px;
  }

  .info-label {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0f0629;
    margin-bottom: 4px;
  }

  .info-value {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: rgba(15, 6, 41, 0.9);
    word-break: break-word;
  }

  .accept-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e8e5ed;
  }

  .accept-status-block {
    flex: 1;
    min-width: 0;
  }

  .not-accepted-text {
    font-family: Sora, sans-serif;
    font-size: 14px;
    color: rgba(15, 6, 41, 0.45);
  }

  .accept-btn {
    flex-shrink: 0;
    background: #0f0629 !important;
    border-color: #0f0629 !important;
    color: #fff !important;
    font-weight: 500;

    &:hover {
      background: #2a1f4a !important;
      border-color: #2a1f4a !important;
    }
  }

  .products-title {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #0f0629;
    margin-bottom: 12px;
  }

  .product-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .product-img-wrap {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: 6px;
    overflow: hidden;
    background: #f3f2f7;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .product-title {
    font-family: Sora, sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: #0f0629;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  :deep(.deal-cell) {
    display: flex;
    gap: 8px;
  }

  .deal-empty {
    color: rgba(15, 6, 41, 0.45);
  }
}
</style>
